const id_sales_invoice = {
    "": "tagihan penjualan",
    add: "buat tagihan penjualan",
    detail: "detail tagihan penjualan",
    edit: "ubah tagihan penjualan",
    history: "riwayat tagihan",

    label: {
        payment_type: "jenis tagihan",
        disc_before_ppn: "potongan sebelum PPN",
        do_list: "daftar DO",
        so_list: "daftar SO",
    },

    message: {
        reject_title: "Apakah Anda yakin untuk membatalkan tagihan ?",
        reject_text: "Masukkan alasan pembatalan tagihan.",
    },

    error: {
        bank_destination: "Tujuan bank tidak boleh kosong.",
        create: "Gagal membuat tagihan penjualan.",
        reject: "Gagal membatalkan tagihan.",
        edit: "Gagal mengubah tagihan penjualan.",
        payment_type: "Jenis tagihan tidak boleh kosong.",
    },

    success: {
        create: "Berhasil membuat tagihan penjualan.",
        reject: "Berhasil membatalkan tagihan.",
        edit: "Berhasil mengubah tagihan penjualan.",
    },
}

export default id_sales_invoice;